import { useRef, useEffect } from 'react';
import correctAudio from '../assets/sounds/correct_answer.mp3';
import incorrectAudio from '../assets/sounds/wrong_answer.mp3';

export const useAudioManager = (questionaudio, questionKey) => {
  const audioRef = useRef(null);
  const currentPlayingAudioRef = useRef(null);
  const hasPlayedForQuestionRef = useRef(null);

  const stopAllAudio = () => {
    if (currentPlayingAudioRef.current) {
      currentPlayingAudioRef.current.pause();
      currentPlayingAudioRef.current.currentTime = 0;
      currentPlayingAudioRef.current = null;
    }
  };

  const playAudio = (audioElement) => {
    stopAllAudio();
    if (audioElement) {
      currentPlayingAudioRef.current = audioElement;
      audioElement.play().catch(() => {});
    }
  };

  useEffect(() => {
    if (questionaudio) {
      audioRef.current = new Audio(questionaudio[0]);
      audioRef.current.volume = 1;
      audioRef.current.playbackRate = 0.9;
    }
  }, [questionaudio]);

  useEffect(() => {
    if (hasPlayedForQuestionRef.current === questionKey) {
      return;
    }

    if (audioRef.current) {
      hasPlayedForQuestionRef.current = questionKey;
      audioRef.current.currentTime = 0;
      audioRef.current.playbackRate = 0.9;
      playAudio(audioRef.current);
    }
  }, [questionaudio, questionKey]);

  const handleAudioReplay = () => {
    if (audioRef.current) {
      audioRef.current.pause();
      audioRef.current.currentTime = 0;
      audioRef.current.playbackRate = 0.9;
      playAudio(audioRef.current);
    }
  };

  const playFeedbackAudio = (isCorrect) => {
    const feedbackAudio = new Audio(isCorrect ? correctAudio : incorrectAudio);
    playAudio(feedbackAudio);
  };

  return {
    handleAudioReplay,
    playFeedbackAudio,
    stopAllAudio
  };
};
